import React from 'react'

import { LeavingGuard } from '@components/utils/LeavingGuard'
import { CurrencyInput } from '@fourthwall/components'
import type { Offer } from '@fourthwall/services/dist/models/offer'
import { useFormik } from '@fourthwall/utils/dist/formik'
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar'

import * as S from './styled'

export type FormValues = Record<string, string>

type Props = {
  variants: Offer.Variant[]
  initialValues: FormValues
  isSubmitting: boolean
  onSubmit: (values: FormValues) => void
}

export const CostsForm = ({ variants, initialValues, isSubmitting, onSubmit }: Props) => {
  const formik = useFormik<FormValues>({ initialValues, enableReinitialize: true, onSubmit })

  if (!Object.keys(initialValues).length) {
    return null
  }

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        {variants.map((variant) => (
          <S.Variant key={variant.id}>
            <S.Label>
              <div>
                {variant.attributesDescription}
                {status === 'UNAVAILABLE' && ` (${status.toLowerCase()})`}
              </div>
              <div>
                <small style={{ color: '#6f6f69' }}>{variant.id}</small>
              </div>
            </S.Label>
            <div>
              <CurrencyInput label="Variant Cost" {...formik.getFieldProps(variant.id)} />
            </div>
          </S.Variant>
        ))}
      </form>
      <ConfirmBar
        isOpen={formik.dirty || isSubmitting}
        isLoading={isSubmitting}
        onConfirm={formik.submitForm}
      />
      <LeavingGuard when={formik.dirty} isValid={formik.isValid} onSave={formik.submitForm} />
    </>
  )
}
